/*
* @Author: shihuaLiu
* @Date: 2021-11-29 14:22:48
 * @Last Modified by: shihuaLiu
 * @Last Modified time: 2022-03-02 18:35:10
*/
<template lang="pug">
  .content
    .top-content
      img.top-content-img(src="../../assets/images/download.png")
      p 扫描二维码下载「乐学宝APP」
</template>

<script>
export default {
  name: 'Download',
  components: {
  },
  data () {
    return {

    }
  },
  computed: {},
  watch: {},
  mounted () {},
  created () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.content{
  overflow-y: scroll;
}
.top-content{
  width: 100%;
  height: auto;
  color: #222222;
  font-size: 20px;
  background-color: #F9F9FB;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.top-content-img {
  width: 200px;
  height: 200px;
  display: inline-block;
  max-width: 100%;
  margin-top: 150px;
}
.top-content p {
  margin: 20px 0 150px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/download/index.vue